import { render, staticRenderFns } from "./VehicleTrendsReport.vue?vue&type=template&id=06090e89&scoped=true"
import script from "./VehicleTrendsReport.vue?vue&type=script&lang=js"
export * from "./VehicleTrendsReport.vue?vue&type=script&lang=js"
import style0 from "./VehicleTrendsReport.vue?vue&type=style&index=0&id=06090e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06090e89",
  null
  
)

export default component.exports